<div class="drawer-form-wrapper">
  <nz-table
    #sortTable
    #rowSelectionTable
    nzShowSizeChanger
    [nzData]="(localadmins$ | async)?.result ?? []"
    nzShowPagination="false"
    nzFrontPagination="false"
    (nzQueryParams)="onQueryParamsChange($event)">
    <thead>
      <tr>
        <th [nzSortFn]="true">Local Administrator</th>
      </tr>
    </thead>
    <tbody>
      @for (data of rowSelectionTable.data; track data) {
        <tr>
          <td>{{ data }}</td>
        </tr>
      }
    </tbody>
  </nz-table>
</div>
